import { Table, Modal, Spin, Button, DatePicker, Input, Drawer, Card as SummaryCard } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";
import { ReactComponent as Arrow } from "../../../assets/icons/arrow-left.svg";
import { ReactComponent as Cash } from "../../../assets/icons/cash.svg";
import { ReactComponent as Card } from "../../../assets/icons/card.svg";
import { ReactComponent as Check } from "../../../assets/icons/check.svg";
import { ReactComponent as Cancel } from "../../../assets/icons/cancel.svg";
import { ReactComponent as Eye } from "../../../assets/icons/eye.svg";
import { getColumnSearchProps } from "../../../utils/tables";
import OrderDetail from "../../../components/OrderDetail";
import { ReactComponent as Calendar } from "../../../assets/icons/calendar.svg";
import styles from "../styles/HistoryUI.module.css";
import { useEffect, useMemo, useState } from "react";

const { RangePicker } = DatePicker;
const { Search } = Input;

const HistoryUI = (props) => {
  const {
    loading,
    history,
    order,
    openOrder,
    closeOrder,
    exportData,
    beginDate,
    endDate,
    handleDates,
    orderSearch,
    loadingOrder,
  } = props;
  const getIcon = (status) => {
    if (status === 15) {
      return <Cancel className={styles.driverIcon} />;
    }
    return <Check />;
  };

  const getMethod = (method) => {
    if (method === 1) {
      return <Cash />;
    }
    return <Card />;
  };

  const platformFilters = Array.from(new Set(history.map(item => item.platformName))).map(platform => ({
    text: platform.charAt(0).toUpperCase() + platform.slice(1),
    value: platform,
  }));

  const platformSummary = useMemo(() => {
    const byPlatform = {};
    history.forEach((o) => {
      const key = o.platformName || "OTRO";
      if (!byPlatform[key]) byPlatform[key] = { count: 0, total: 0 };
      byPlatform[key].count += 1;
      byPlatform[key].total += parseFloat(o.total) || 0;
    });
    return byPlatform;
  }, [history]);

  const cirebaFailedByPlatform = useMemo(() => {
    const byPlatform = {};
    history
      .filter((o) => (!o.cireba_remote_id || o.cireba_remote_id === "0") && o.status !== 6 && o.status !== 20)
      .forEach((o) => {
        const key = o.platformName || "OTRO";
        byPlatform[key] = (byPlatform[key] || 0) + 1;
      });
    return byPlatform;
  }, [history]);

  const [drawerWidth, setDrawerWidth] = useState(1150);
  
  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth <= 768 ? "100%" : 1150);
    };

    handleResize(); // set on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    {
      title: "Origen",
      dataIndex: "platformName",
      align: "center",
      filters: platformFilters,
      onFilter: (value, record) => record.platformName === value,
      filterMultiple: false,
    },
    {
      title: "Ticket",
      dataIndex: "ticket",
      align: "center",
      ...getColumnSearchProps("ticket"),
    },
    {
      title: "Usuario",
      dataIndex: "id_user__fullname",
      ...getColumnSearchProps("id_user__fullname"),

    },
    {
      title: "Fecha",
      dataIndex: "created_time",
      render: (val) => moment(val).format("DD/MM/YY - hh:mma"),
      align: "center",
    },
    {
      title: "Sucursal",
      dataIndex: "branch",
      align: "center",
      render: (val) => val.zone || "-",
      ...getColumnSearchProps("branch_name"),
    },
    {
      title: "Monto",
      dataIndex: "total",
      render: (val) => `$${parseFloat(val).toFixed(2)}`,
      align: "center",
    },
    {
      title: "Método",
      dataIndex: "payment_method",
      render: (val) => getMethod(val),
      align: "center",
      filters: [
        {
          value: 1,
          text: "Efectivo",
        },
        {
          value: 2,
          text: "Tarjeta",
        },
      ],
      onFilter: (value, record) => record.payment_method === value,
      filterMultiple: false,
    },
    {
      title: "Estado",
      dataIndex: "status",
      render: (val) => getIcon(val),
      align: "center",
      filters: [
        {
          value: 12,
          text: "Completadas",
        },
        {
          value: 15,
          text: "Canceladas",
        },
      ],
      onFilter: (value, record) => record.status === value,
      filterMultiple: false,
    },
    {
      title: "Tipo de Orden",
      dataIndex: "orderTypeName",
      align: "center",
      filters: [
        { value: "PEDIDOS YA", text: "PEDIDOS YA" },
        { value: "UBER EATS", text: "UBER EATS" },
        { value: "PARA LLEVAR", text: "PARA LLEVAR" },
        { value: "DOMICILIO", text: "DOMICILIO" },
      ],
      onFilter: (value, record) => record.orderTypeName === value,
      render: (value, record) => ( record.orderTypeName ),
    },
  /*   {
      title:"Acciones",
      dataIndex:"id",
      align:"center",
      render:()=> <Button className={styles.activeOrder}>Activar Order</Button>
    }, */
    {
      title: "Ver detalle",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <button
          disabled={loadingOrder}
          onClick={() => openOrder(val)}
          className={styles.eye}
        >
          {loadingOrder === val ? <Spin size="small" /> : <Eye />}
        </button>
      ),
    },
  ];
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to={"/"} className={styles.back}>
          <div className={styles.backButton}>
            <Arrow />
          </div>
          <span>Ordenes</span>
        </Link>
        <div>
          <Search
            placeholder="Buscar por código"
            className={cx(styles.input, styles.search)}
            allowClear
            enterButton
            size="large"
            loading={loading}
            onSearch={orderSearch}
          />
          <RangePicker
            size="large"
            suffixIcon={<Calendar />}
            className={styles.picker}
            placeholder={["Fecha Inicio", "Fecha Final"]}
            allowClear={false}
            value={[beginDate, endDate]}
            onChange={handleDates}
          />
          <Button
            disabled={loading}
            size="large"
            type="primary"
            onClick={exportData}
          >
            Exportar
          </Button>
        </div>
      </div>
      {!loading ? (
        <div className={styles.orders}>
          <div className={styles.summaryWrapper}>
            <SummaryCard className={styles.summaryCard}>
              {Object.entries(platformSummary).map(([platform, data]) => (
                <SummaryCard.Grid key={platform} className={styles.summaryGrid} hoverable={false}>
                  <p className={styles.summaryHeading}>${data.total.toFixed(2)}</p>
                  <p className={styles.summarySubheading}>
                    {platform} — {data.count} {data.count === 1 ? "ORDEN" : "ORDENES"}
                  </p>
                </SummaryCard.Grid>
              ))}
              {Object.entries(cirebaFailedByPlatform).map(([platform, count]) => (
                <SummaryCard.Grid
                  key={`failed-${platform}`}
                  className={cx(styles.summaryGrid, styles.summaryGridWarning)}
                  hoverable={false}
                >
                  <p className={cx(styles.summaryHeading, styles.summaryHeadingWarning)}>
                    {count}
                  </p>
                  <p className={styles.summarySubheading}>{platform} — NO INGRESADAS</p>
                </SummaryCard.Grid>
              ))}
            </SummaryCard>
          </div>
          <Table dataSource={history} columns={columns} rowKey="id" />
        </div>
      ) : (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      )}

      <Drawer
        destroyOnClose
        placement="right"
        visible={order}
        width={drawerWidth}
        closable={true}
        onClose={closeOrder}
        className={styles.modalOrder}
      >
        {order && (
          <OrderDetail
            order={order}
          />
        )}
      </Drawer>
    </div>
  );
};

export default HistoryUI;
